import { Memo } from './Memo';
export default Memo;